<template>
  <v-card class="courseListWrap">
    
    <div class="header" v-if="!isMobile.isMobile">
      <span style="width: 80px; float: left; color: #fff; margin: 20px 10px 20px 26px"
        >课程列表</span
      >
      <span class="addCourse" v-hasPermi="['dev::course::add']" @click="toNewCourse">
        <v-btn large class="md-button md-success dropdown-toggle addModel">
          <span class="iconfont icon-tianjia" style="font-size: 17px; margin-right: 2px"></span
          >新建课程
        </v-btn>
      </span>

      <div style="overflow: hidden; height: auto; float: right; width: auto">
        <div class="queryWrap">
          <div class="selectBtn">
            <v-btn
              large
              class="md-button md-success dropdown-toggle addModel"
              @click="setBtnSelect"
            >
              <span v-if="toggle_exclusive == 0" class="iconfont btnSelect icon-qiapianxuanze-">
                <md-tooltip md-direction="top" class="toopZindex">卡片模式</md-tooltip>
              </span>

              <span v-if="toggle_exclusive == 1" class="iconfont btnSelect icon-liebiao">
                <md-tooltip md-direction="top" class="toopZindex">列表模式</md-tooltip>
              </span>
            </v-btn>
          </div>

          <div style="display: inline-block" @mousedown="mouseDown">
            <el-cascader
              size="small"
              placeholder="全部"
              @change="onchange"
              v-model="optionsValue"
              :props="cascaderProps"
              id="coursefilterWrap"
              ref="coursefilterWrap"
              :show-all-levels="true"
            >
              <template slot-scope="{ node, data }">
                <span style="display: block" @click="onClick(node)">{{ data.name }}</span>
              </template>
            </el-cascader>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="coureWraps">
        <v-card-text style="padding: 0px; min-height: 550px;position: relative">
          <!-- <md-content class="md-scrollbar" style="position: relative"> -->
            <div class="filterValue">
              <v-text-field
                v-model="queryParams.name"
                append-icon="mdi-magnify"
                label="请输入课程名称"
                single-line
                hide-details
                @input="setqueryParamsName"
                @keydown="keydownSearch"
              ></v-text-field>

              <md-tooltip md-direction="top" v-if="!isMobile.isMobile">按回车以检索</md-tooltip>
            </div>
            <v-tabs
              v-model="tab"
              color="green"
              class="custom-tab"
              id="custom-tab"
              :items="false"
              align-tabs="center"
              style="margin-left: 13px; margin-right: 13px; margin-top: 8px; background-color: none
              ;"
            >
              <v-tab :value="item.value" v-for="(item, index) in tabs" :key="index">{{
                item.label
              }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item key="tab-base">
                <!-- 公开课程 -->
                <CourseCard :tabIndex="tab" @setParentTab='selectTab(1)'  ref="CourseCard" v-if="tab == 0"></CourseCard>
              </v-tab-item>
              <v-tab-item key="tab-ext">
                <!-- 我的课程 -->
                <CourseCard :tabIndex="tab" @setParentTab='selectTab(1)' ref="CourseCard" v-if="tab == 1"></CourseCard>
              </v-tab-item>
              <v-tab-item key="tab-act">
                <!-- 协作课程 -->
                  <CourseCard :tabIndex="tab" @setParentTab='selectTab(1)' ref="CourseCard" v-if="tab == 2"></CourseCard>
              </v-tab-item>
            </v-tabs-items>
   
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>
<script>
import TaskList from './Main/Action/TaskList.vue';
// import { Pagination } from '@/components';
import { mapGetters } from 'vuex';

import { categoryList } from '../../api/user';
import formheadertypeVue from './courselistComponents/formheadertype.vue';
import CourseCard from '/src/components/Cards/CourseCard.vue';
export default {
  components: {
    // Pagination,
    TaskList,
    formheadertypeVue,
    CourseCard,
  },
  filters: {
    referFilter(val) {
      if (!val) return '';

      const list = [
        {
          key: 'bk',
          value: '本科',
        },
        {
          key: 'gz',
          value: '高职',
        },
        {
          key: 'gj',
          value: '高技',
        },
        {
          key: 'zz',
          value: '中职',
        },
        {
          key: 'jx',
          value: '技校',
        },
        {
          key: 'bjrs',
          value: '毕节人社',
        },
      ];
      return typeof val === 'string'
        ? list.find(item => item.key === val)?.value
        : list
            .filter(item => val.some(i => i === item.key))
            .map(item => item.value)
            .join('、');
    },
  },
  computed: {
    ...mapGetters(['courseList', 'cardType', 'courseListPage','isMobile']),
    pageCount() {
      return this.pagination.total
        ? Math.ceil(this.pagination.total / this.pagination.itemsPerPage)
        : 0;
    },
    cardType() {
      return this.$store.state.task.cardType;
    },
    courseListPage() {
      return this.$store.state.task.courseListPage;
    },
  },
  created() {
    this.toggle_exclusive = this.cardType;
    this.getTab()
  },
  data() {
    return {
      tabs: [
        {
          label: '公开课程',
          value: '0',
        },
        {
          label: '我的课程',
          value: '1',
        },
        {
          label: '协作课程',
          value: '2',
        },
      ],
      tab: '',

      cascaderKey: 0,
      optionsValue: ['all'],
      cascaderProps: {
        label: 'name',
        value: 'code',
        lazy: true,
        lazyLoad: (node, resolve) => {
          let that = this;
          const { level } = node;
          setTimeout(() => {
            if (node.level == 0) {
              let options = [
                {
                  code: 'all',
                  name: '全部',
                  level: 0,
                  leaf: true,
                  children: [],
                },
                // { code: 'bjrs', name: '毕节人社', level: 0, leaf: false },
                { code: 'bk', name: '本科', level: 0, leaf: false },
                { code: 'gz', name: '高职', level: 0, leaf: false },
                { code: 'zz', name: '中职', level: 0, leaf: false },
                { code: 'gj', name: '技师学院', level: 0, leaf: false },
                { code: 'jx', name: '技校', level: 0, leaf: false },
                { code: 'qy', name: '企业', level: 0, leaf: false },
              ];

              resolve(options);
            }
            if (node.level == 1) {
              if (node.value == '') {
                return;
              }
              let params = {
                cate_type: node.value || '',
                level: '1',
                parentCode: '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data &&
                    res.data.forEach(item => {
                      item.leaf = false;
                    });
                  if (params.cate_type !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '123456',
                      children: [],
                      leaf: true,
                      level: 1,
                    });
                  }
                  resolve(res.data);
                }
              });
            }
            if (node.level == 2) {
              let params = {
                cate_type: node.parent.value || '',
                level: '2',
                parentCode: node.value || '',
              };
              categoryList(params).then(res => {
                if (res.data) {
                  res.data.forEach(item => {
                    item.leaf = true;
                  });
                  if (params.parentCode !== 'all') {
                    res.data.unshift({
                      cate_type: 'all',
                      code: 'all',
                      name: '全部',
                      _id: '111111111111111',
                      children: [],
                      leaf: true,
                      level: 2,
                    });
                  }

                  resolve(res.data);
                }
              });
            } else if (node.level > 2) {
              resolve([]);
            }
          }, 100);
        },
      },

      options: [
        { value: 'all', label: '全部', level: 0 },
        { value: 'bjrs', label: '毕节人社', level: 0 },
        { value: 'bk', label: '本科', level: 0 },
        { value: 'gz', label: '高职', level: 0 },
        { value: 'zz', label: '中职', level: 0 },
        { value: 'gj', label: '技师学院', level: 0 },
        { value: 'jx', label: '技校', level: 0 },
        { value: 'qy', label: '企业', level: 0 },
      ],
      btns: [['Removed', '0']],
      colors: ['deep-purple accent-4'],
      items: [...Array(4)].map((_, i) => `Item ${i}`),
      x: true,
      y: true,

      majorGroup: '',
      majorGroup2: '',
      listData1: [
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      listData2: [],
      listData3: [],
      type: 'bjrs',
      queryform: {
        one: {
          name: '适用',
          code: '',
        },
        level: '',
        parentCode: {
          name: '专业大类',
          code: '',
        },
        three: {
          name: '专业类',
          code: '',
        },
      },
      typeList: [
        { code: '', name: '全部' },
        { code: 'bjrs', name: '毕节人社' },
        { code: 'bk', name: '本科' },
        { code: 'gz', name: '高职' },
        { code: 'zz', name: '中职' },
        { code: 'gj', name: '技师学院' },
        { code: 'jx', name: '技校' },
        { code: 'qy', name: '企业' },
      ],
      typeValueArr: [],
      typeArr: [],
      centerValue: '',
      rightValue: '',
      left_refer_list: [
        { id: 1, value: 'bjrs', name: '毕节人社', isCheck: false },
        { id: 2, value: 'bk', name: '本科', isCheck: false },
        { id: 3, value: 'gz', name: '高职', isCheck: false },
        { id: 4, value: 'zz', name: '中职', isCheck: false },
        { id: 5, value: 'gj', name: '技师学院', isCheck: false },
        { id: 6, value: 'jx', name: '技校', isCheck: false },
        { id: 7, value: 'qy', name: '企业', isCheck: false },
      ],
      centerListLoading: false, //中间loading
      rightListLoading: false, //中间loading

      center_refer_list: [],
      copy_center_refer_list: [],
      right_refer_list: [],
      copy_right_refer_list: [],
      select: { state: '全部', abbr: 'ALL' },
      items: [
        { state: '全部', abbr: 'ALL' },
        { state: '已发布', abbr: 'Published' },
      ],
      // 分页
      toggle_exclusive: 0,
      scoureImg: require('/public/img/log.png'),

      headers: [
        {
          text: '序 号',
          align: 'start',
          value: 'num',
          width: 90,
        },
        { text: '名 称', align: 'start', value: 'name', width: 300 },
        { text: '签约院校', align: 'start', value: 'university' },
        { text: '学院/系', align: 'start', value: 'college' },
        { text: '教研团队', align: 'start', value: 'team' },
        { text: '适 用', align: 'start', value: 'refer', width: 120 },
        { text: '负责人', align: 'start', value: 'manager', width: 120 },
        {
          text: '操作',
          align: 'center',
          value: 'optionone',
          sortable: false,
          width: 140,
        },
      ],
      tableData: [],
      currentSort: 'name',
      currentSortOrder: 'asc',
      queryParams: {},
      queryformVisible: false,
      //本地缓存
      saveCourseForm: {
        // currentPage: _this.pagination.page,
        currentPage: '',
        // perPage: _this.pagination.itemsPerPage,
        perPage: '',
        // name: _this.queryParams.name,
        name: '',
        // filterValue: this.select.abbr,
        // refer: this.refer||"",
        refer: '',
        // majorGroup: this.majorGroup||"",
        majorGroup: '',
        // majorGroup2: this.majorGroup2||"",
        majorGroup2: '',
      },
      tooltipVisible: false,
      tooltipValue: '全部',
    };
  },
  watch: {
    optionsValue(val) {
      if (this.$refs.coursefilterWrap && val.length == 3) {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
      if (this.$refs.coursefilterWrap && val.length == 2 && val[1] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }

      if (this.$refs.coursefilterWrap && val.length == 1 && val[0] == 'all') {
        this.$refs.coursefilterWrap.dropDownVisible = false;
      }
    },
    toggle_exclusive(news) {
      this.$store.state.task.cardType = news;
    },

    refer(item) {
      this.saveCourseForm.refer = item;
    },
    majorGroup(item) {
      this.saveCourseForm.majorGroup = item;
    },
    majorGroup2(item) {
      this.saveCourseForm.majorGroup2 = item;
    },
    tab(news){
      window.localStorage.setItem('courseTab',news)
      this.optionsValue =['all'];
      this.setFilter()
    }
  },
  methods: {
    selectTab(value=0){
      window.localStorage.setItem('courseTab',value)
      this.tab = value
      this.optionsValue =['all'];
    },
    getTab(){
      if(window.localStorage.getItem('courseTab')){
        let tabs = parseInt(window.localStorage.getItem('courseTab'))
        this.tab = tabs
      }
    },
    onClick(data) {
      this.optionsValue = data.path;
      this.$refs.CourseCard.selectCard(this.optionsValue);
      // this.$refs.SimClassCard.selectCard(this.optionsValue);;
      this.setFilter(data);
      this.mouseenter(data);
    },
    mouseenter(data) {
      let str = '';
      if (data && data.pathLabels) {
        if (data.pathLabels.length == 1) {
          str = data.pathLabels[0];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 2) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1];
          this.tooltipValue = str;
        } else if (data.pathLabels.length == 3) {
          str = data.pathLabels[0] + '/' + data.pathLabels[1] + '/' + data.pathLabels[2];
          this.tooltipValue = str;
        }
        this.tooltipVisible = true;
      } else {
        this.tooltipValue = '全部';
      }
    },
    setFilter(data) {
      if (!data) {
        let getNode = document.querySelector('.el-cascader .el-input__inner');
        getNode.style.width = 80 + 'px';
        return;
      }
      let getNode = document.querySelector('.el-cascader .el-input__inner');
      let str = '';
      if (data.pathLabels && data.pathLabels.length > 0) {
        data.pathLabels.forEach(item => {
          str += item;
        });
      }

      if (str.length <= 5) {
        getNode.style.width = (str.length + 3) * 18 + 'px';
        return;
      }
      if (str.length > 17) {
        getNode.style.width = str.length * 18 + 'px';
        return;
      }
      getNode.style.width = (str.length + 2) * 18 + 'px';
    },
    mouseDown() {
      this.tooltipVisible = false;
    },

    onchange(data) {},

    async openClient(item) {
      const params = encodeURIComponent(
        JSON.stringify({
          token: localStorage.getItem('token'),
          course: item.project.course,
          projectId: item.project._id,
          version: item.version,
          platform: item.platform ?? 'PC',
          // , runtime: 'meta_trial'
          runtime: process.env.VUE_APP_RUNTIME,
        })
      );
      location.href = `MetaSpaceProject://${params}`;
    },
    setBtnSelect() {
      this.toggle_exclusive = !this.toggle_exclusive;
    },
    resetquery() {
      this.queryform.parentCode = {
        name: '专业大类',
        code: '',
      };
      this.queryform.three = {
        name: '专业类',
        code: '',
      };
      this.listData2 = [];
      this.listData3 = [];
    },

    setqueryParamsName(name) {
      this.$refs.CourseCard.saveCourseForm.name = name;
    },

    toNewCourse() {
      this.$router.push({ path: './newcourse' });
    },

    keydownSearch(e) {
      // 点击Enter
      if (e.keyCode === 13) {
        this.$refs.CourseCard.pagination.page = 1;
        this.$refs.CourseCard.setSearchQuery(this.queryParams);
      }
    },
  },
  mounted() {
    let _this = this;
    this.$EventBus.$on('setCardStyle', function (type) {
      _this.toggle_exclusive = type;
    });
    this.setFilter(); 
    if(this.$route.query&&this.$route.query.tab){
      this.tab  = parseInt(this.$route.query.tab)
    }
  },
};
</script>

<style scoped>
/* 影响全局表格样式 */
@media (max-width: 599px) {
  .selectBtn {
    flex: 1;
    /* width: 98%; */
    margin: 0 auto;
    text-align: right;
    padding: 0 8px 0 0;
  }
}

.header {
  background: #4caf50 !important;
  height: 64px;
  overflow: hidden;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  /* margin-bottom: 0px; */
  margin: 0px 0px 0px 0px;
}
.quertHeader {
  padding: 0 15px;
}

.theme--dark.v-btn.v-btn--has-bg {
  background: #2e694b !important;
}
.addCourse {
  float: left;
  margin-left: -20px;
  height: 61px;
  line-height: 61px;
  /* margin-top: 10px; */
}
.addCourse svg {
  width: 1.4em !important;
  height: 1.4em !important;
  fill: currentColor;
  overflow: hidden;
  /* transform: translateY(6px); */
  color: #fff;
  cursor: pointer;
}

.selectBtn {
  float: right;
  margin-right: 10px;
  height: auto;
  overflow: hidden;
  height: 62px;
  line-height: 62px;
  cursor: pointer;
}

.selectBtn svg {
  width: 1.5em !important;
  height: 1.3em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  /* color: #4caf50; */
}

.toggleBtn >>> svg {
  width: 1.5em !important;
  height: 1.5em !important;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  /* color: #fff; */
}
.toggleBtn {
  /* background: #fff !important; */
  transform: translateY(5px);
}

/* .icon1:hover {
  color: #fff;
} */

.theme--light.v-btn.v-btn--has-bg {
  /* background: #4caf50; */
}

/* .selectBtn >>> .v-item--active,
.v-btn--active {
  color: #43a047;
} */

.queryWrap {
  /* margin-top: 18px; */
  width: auto;
  float: right;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-label {
  color: #fff !important;
}
.queryWrap .v-input >>> .v-input__control .v-input__slot::before {
  border-color: #fff;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-select__selections {
  color: #fff !important;
}

.queryWrap .v-input >>> .v-input__control .v-input__slot .v-input__append-inner .v-input__icon i {
  color: #fff !important;
}

.coureWraps {
  /* min-height: 650px; */
  overflow-x: hidden;
  /* padding-top: 20px; */
  /* max-height: 660px; */
  /* background-image: url('@/assets/socore_Img.png');
  background-image: url('../../assets/img/socore_Img'); */
}
.md-content {
  width: 100%;
  max-height: 850px;
  overflow: auto;
}
.cardStyle {
  width: 24% !important;
  height: 200px;
  float: left;
}

.coureListImg {
  width: 100%;
  transition: 0.2s;
}

.courseList {
  /* margin: 10px 0; */
  height: 245px;
  max-height: 245px;
  cursor: pointer;
}

.v-card {
  position: relative;
  overflow: hidden;
}

/* .pubInput{
  width: 100px !important;
}

.pubInput >>>.v-input__control{
  width: 100px !important;
    
} */

.coureWraps >>> .v-card:hover .openClient {
  display: block;
}
.openClient {
  position: absolute;
  right: 10px;
  /* top: 0; */
  bottom: 5px;
  margin: auto;
  width: 32px;
  border-radius: 5px;
  height: 32px;
  z-index: 888;
  cursor: pointer;
  background-image: url('../../assets/img/openClient.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: none;
}

.courseList:hover .coureListImg {
  opacity: 0.8;
}

.md-layout-item {
  padding: 4px 10px 4px 10px;
}

.btnSelect {
  /* padding: 5px 6px; */
  font-size: 20px;
  color: #fff;
}

.selectWrap {
  background: #fff;
}

.listWrap {
  background: #000000a3;
  margin-top: 0px;
  margin-left: 20px;
  /* border: 1px solid #fff; */
  border-radius: 5px;
}

.listItem {
  cursor: pointer;
  min-height: 38px;
  padding: 0 10px;
  font-size: 13px;
}
.listItem:hover {
  background-color: #494949 !important;
}
.icon-shanchutianchong {
  margin-right: 7px;
  color: #fff;
}

.selectWrapAdd {
  display: inline-block;
  position: relative;
}

/* >>> .sortable{
  padding: 0 6px !important;
} */

.conWrap {
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 0px;
}

#coursefilterWrap {
  margin-top: 18px;
  margin-left: 10px;
  /* width: 320px; */
}

#coursefilterWrap >>> .el-input:hover {
  /* box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12); */
  box-shadow: 0 0 6px 1px #70707052;
  border-radius: 4px;
}
#coursefilterWrap >>> .el-input .el-input__inner {
  border: none;
  background: #4caf50 !important;
  color: #fff;
  font-weight: 700;
}
#coursefilterWrap >>> .el-input .el-input__inner::placeholder {
  color: #fff;
}
#coursefilterWrap >>> .el-input .el-input__suffix {
  color: #fff;
}

.el-cascader-menu {
  max-width: 250px;
}

.toopZindex {
  z-index: 99999;
}

.custom-tab {
  margin-left: 0px;
  margin-right: 0px;
}

.filterValue {
  margin: 0 auto;
  width: 300px;
  /* position: absolute;
  top: 10px;
  right: 10px; */
  z-index: 99;
}

.filterValue .v-text-field {
  padding-top: 0px !important;
  margin-top: 0px !important;
}
.messageWrap{
  width: 100px;
  position: absolute;
  top: 10px;
  right: 300px;
  z-index: 900;  
}

.courseListWrap{
 margin-left: 13px
}

@media (max-width: 600px) {
  .titleStyle {
    margin: 0px 0px 0px 10px !important;
  }
  .filterValue {
    width: 100%;
    margin-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
  }
  .ahoverdown{
    width: 95px;
  }
  .noDataGuJia{
    width: 98%;
    position: absolute;
    top: 100px;
  }
  .courseListWrap{
      margin-left: 15px;
      margin-right:15px;
  }
}

@media (min-width: 600px) {
  .filterValue {
    margin: 0 auto;
    width: 300px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 99;
  }
}

</style>
